import { render } from "./RetailTr.vue?vue&type=template&id=783b811d&scoped=true"
import script from "./RetailTr.vue?vue&type=script&lang=js"
export * from "./RetailTr.vue?vue&type=script&lang=js"

import "./RetailTr.vue?vue&type=style&index=0&id=783b811d&scoped=true&lang=css"

import exportComponent from "/Users/cole/Desktop/중요/tcd-partnerpage-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-783b811d"]])

export default __exports__